import { useEffect, useState } from 'react'

import { MoneyInputProps } from './money-input.types'
import { CurrencyOnlyValue } from './components/money-field.types'

import { CurrencySelector } from './components/currency-selector'
import {
  CurrencyCode,
  createMoney,
  toMajorUnits,
} from '@poweredbypercent/utility-core'
import {
  CurrencyFlagBox,
  CurrencyInputWrapper,
} from './components/currency-components'
import { MoneyField } from './components/money-field'

export const MoneyInput = ({
  defaultCurrency,
  currencies,
  currencySearchPlaceholder,
  currencySelectorDisabled,
  borderRadiiSize,
  ...props
}: MoneyInputProps) => {
  const [currency, setCurrency] = useState<CurrencyCode>(defaultCurrency)

  useEffect(() => {
    setCurrency((prev) => (defaultCurrency !== prev ? defaultCurrency : prev))
  }, [defaultCurrency])

  return (
    <CurrencyInputWrapper>
      <MoneyField
        currency={currency}
        borderRadiiSize={borderRadiiSize}
        syncCurrencyToParent={false}
        {...props}
      />
      <CurrencyFlagBox>
        <CurrencySelector
          defaultCurrency={currency}
          onValueChange={(v) => {
            if (v) {
              setCurrency(v)
              const value = props.value
              if (
                value?.amount !== undefined &&
                value?.amount !== null &&
                value?.currency
              ) {
                const majorAmount = toMajorUnits(value.amount, value.currency)
                props.onValueChange?.(createMoney(majorAmount, v), undefined)
              } else {
                const currencyOnly: CurrencyOnlyValue = {
                  amount: undefined,
                  currency: v,
                }
                props.onValueChange?.(currencyOnly, undefined)
              }
            }
          }}
          placeholder={currencySearchPlaceholder}
          currencies={currencies}
          disabled={currencySelectorDisabled || props.disabled}
          borderRadiiSize={borderRadiiSize}
        />
      </CurrencyFlagBox>
    </CurrencyInputWrapper>
  )
}
